<script>
  import CloseIconButton from "../IconButtons/CloseIconButton.svelte";

  export let title

  /**
   * If this prop is provided, a close button is injected on the top-right,
   *  and this is called when the button is clicked.
   * @type {() => void}
   */
  export let onClickClose = null
</script>

<div class="title-container">
  <div class="title">
    {#if title}
      {title}
    {:else}
      <slot />
    {/if}
  </div>
  {#if onClickClose}
    <CloseIconButton onClick={onClickClose} />
  {/if}
</div>

<style>
  .title {
    font-weight: bold;
    flex-grow: 1;
    font-size: 24px;
    color: #888888;
    line-height: 1;
  }
  .title-container {
    padding: 24px;
    display: flex;
    justify-content: space-between;
  }
</style>
